import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { TRenderOptionType, TSingleSelectFilterGroupInfo, TSingleSelectOption } from '../filter/model/ui-filter.types';
import { SingleSelectPopoverComponent } from '../single-select-popover/single-select-popover.component';
import { createThrottler } from '@monorepo/utils';

@Component({
  selector: 'monorepo-inline-single-select',
  templateUrl: './inline-single-select.component.html',
  styleUrls: ['./inline-single-select.component.scss'],
})
export class InlineSingleSelectComponent {
  @Input() inlineSingleSelectInput!: TSingleSelectFilterGroupInfo;
  @Input() popoverRenderOptionType: TRenderOptionType = 'INLINE';
  @Input() isDisabled: boolean = false;
  @Output() selectedItemEvent = new EventEmitter<TSingleSelectFilterGroupInfo>();
  #throttle = createThrottler();

  constructor(public popoverController: PopoverController, private modalController: ModalController) {}

  onSelection(data?: TSingleSelectOption) {
    if (data) {
      const emitVal = {
        ...this.inlineSingleSelectInput,
        selectedValue: data,
      };
      this.selectedItemEvent.emit(emitVal);
    }
  }

  async presentPopover(ev: Event) {
    switch (this.popoverRenderOptionType) {
      case 'INLINE':
        this.#throttle('popover', () => this.createPopover(ev, 'single-select-popover-inline'), 1000);
        break;
      case 'MODAL':
        this.#throttle('modal', () => this.createModal('single-select-popover-component-modal'), 1000);
        break;
    }
  }

  async createModal(cssClass: string) {
    const modal = await this.modalController.create({
      component: SingleSelectPopoverComponent,
      cssClass,
      componentProps: {
        optionList: this.inlineSingleSelectInput.items,
        popoverRenderOptionType: this.popoverRenderOptionType,
      },
    });
    await modal.present();
    const dismissVal = await modal.onWillDismiss();
    if (dismissVal.role === 'SELECTION') this.onSelection(dismissVal.data as TSingleSelectOption);
  }

  async createPopover(ev: Event, cssClass: string) {
    const popover = await this.popoverController.create({
      component: SingleSelectPopoverComponent,
      event: ev,
      cssClass,
      animated: false,
      componentProps: {
        optionList: this.inlineSingleSelectInput.items,
        selectedOption: this.inlineSingleSelectInput.selectedValue,
        searchPlaceholder: this.inlineSingleSelectInput.searchPlaceholder,
      },
      translucent: true,
    });
    await popover.present();
    const dismissVal = await popover.onWillDismiss();
    if (dismissVal.role === 'SELECTION') this.onSelection(dismissVal.data as TSingleSelectOption);
  }
}
